<template>
  <Card class="unlock-aa" :style="styles">
    <CardText>
      <VText variant="h2" style="margin-bottom: 0.3rem"
        >Get Advanced Analytics</VText
      >
      <VText
        >Select our Pro+ plan or the analytics add-on to unlock these powerful
        features.</VText
      >
      <ul>
        <li>😍 Top-line stats on all of your profiles</li>
        <li>✨ Events and tracking reports</li>
        <li>🔥 Filtering and custom dates</li>
        <li>⬇️ Download your analytics data as a .csv</li>
        <li>🤓 Lifetime data storage</li>
        <li>💅 Style your analytics</li>
      </ul>
      <Button
        style="margin-top: 1.5rem"
        href="https://app.campsite.bio/account/change-plan"
        target="_blank"
        color="secondary"
        >Upgrade now</Button
      >
    </CardText>
  </Card>
</template>

<script>
import tinyColor from 'tinycolor2';
import {
  useTheme,
  Card,
  CardText,
  VText,
  Button,
} from '@campsite-bio/component-lib';
import { computed } from '@nuxtjs/composition-api';

export default {
  name: 'UnlockAdvancedAnalytics',

  components: {
    Card,
    CardText,
    VText,
    Button,
  },

  setup() {
    const theme = useTheme();

    const styles = computed(() => {
      return {
        '--c-bg-color': tinyColor(theme.value.colors.primary)
          .setAlpha(0.05)
          .toRgbString(),
      };
    });

    return { styles };
  },
};
</script>

<style lang="scss" scoped>
.unlock-aa.unlock-aa {
  background: var(--c-bg-color);
  border-radius: var(--g-border-radius-standard);
  border-radius: Min(
    var(--g-border-radius-standard),
    var(--g-border-radius-min)
  );
  margin: 2rem 0;

  h2 {
    margin: 0;
  }

  ul {
    list-style: none;
    margin: 1rem 0 0;
    padding: 0;

    @media (min-width: 544px) {
      columns: 2;
    }
  }

  li {
    padding: 0.2rem 0;
  }
}
</style>
